import { Tagline1, Tagline2, Title } from "../../constants";
import img2 from "../../img/intro-carousel/img1.png";

const HomePage: React.FC<{}> = () => {
  return (
    <div>
      {" "}
      <section id="intro">
        <div className="intro-container">
          <div
            id="introCarousel"
            className="carousel slide carousel-fade"
            data-ride="carousel"
          >
            <div className="carousel-inner" role="listbox">
              <div className="carousel-item active">
                <div className="carousel-container">
                  <div className="carousel-content">
                    <h2>{Title}</h2>
                    <p>
                      {Tagline1}
                      <br></br>
                      {Tagline2}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="carousel-item"
                style={{
                  backgroundImage: `url(${img2})`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
